module.exports = __webpack_public_path__ + "static/media/modal_title_icon.7a5924fa.svg";